import { defineMessages } from 'react-intl'

const messages = defineMessages({
  familyFriendly: {
    id: 'global.family-friendly',
  },
  familyFriendlyHint: {
    id: 'global.family-friendly-hint',
  },
})

export default messages
